<template>
  <div class="paw-install-award">
    <div class="paw-install-award-shadow" @click="close"></div>
    <div class="paw-install-award-main" :style="pwaAwardPopupBg">
      <div class="main-text">
        <p style="white-space: break-spaces;line-height: 1.5;" v-html="letter.v3LaunchFromDesktopAndRewardToMailbox"></p>
      </div>
      <a
        href="javascript:;"
        class="main-install"
        @click="close"
        :style="pwaAwardPopupBtn"
      >
        {{ letter.v3Confirm }}
      </a>
  
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import { clickButton } from '@plugins/biPoint/_configWebstoreV35';

export default {
  name: 'PwaGotoAwardTipsPopup',
  emits: ['install', 'close'],
  computed: {
    ...mapState({
      letter: state => state.letter,
      picList: state => state.page.picList
    }),
    ...mapGetters(['gameInfoConfig']),
    pwaAwardPopupBg() {
      if (this.picList?.pwaAwardPopupBg) {
        return `background-image:url(${this.picList?.pwaAwardPopupBg})`;
      }
      return '';
    },
    pwaAwardPopupBtn() {
      if (this.picList?.pwaAwardPopupBtn) {
        return `background-image:url(${this.picList?.pwaAwardPopupBtn})`;
      }
      return '';
    }
  },
  methods: {
    install() {
      this.$emit('install');
    },
    close() {
      // 打点上报
      clickButton({
        btnName: 'close_pwa_install_popup',
        locationKey: this.$route.meta.pageName
      });
      this.$emit('close');
    }
  }
};
</script>

<style lang="scss" scoped>
.paw-install-award {
  z-index: 999;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  &-shadow {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba($color: #000000, $alpha: 0.4);
  }
  &-main {
    overflow: hidden;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
    width: 498px;
    height: 468px;

    font-size: 20px;
    color: #fff;

    .main {
      &-text {
        margin-top: 184px;
        padding: 0 22px;
        font-size: 24px;
        text-align: center;
        p {
          line-height: 120%;
        }
        p:nth-child(1) {
          margin-bottom: 16px;
          color: #fff;
        }
        p:nth-child(2) {
          margin-bottom: 20px;
          // 文字渐变色
          font-weight: bold;
          background-image: linear-gradient(to bottom, #fffdd0, #ffdf61);
          -webkit-background-clip: text;
          color: transparent; /* Fallback for non-webkit browsers */
          background-clip: text;
          -webkit-text-fill-color: transparent;
        }
      }
      &-install,
      &-close {
        display: block;
        margin: auto;
        text-align: center;
      }
      &-install {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-bottom: 20px;
        background-size: contain;
        background-position: center;
        background-repeat: no-repeat;
        width: 256px;
        height: 81px;
        //padding-top: 10px;
        line-height: 30px;
        font-size: 24px;
        font-weight: bold;
        color: #ffffff;
      }
      &-close {
        font-size: 20px;
        color: #ffffff;
      }
    }
  }
}
</style>
